import $ from 'jquery';

import Headroom from 'headroom.js';

$(document).ready(function () {
    $('.menu-toggle').on('click', function() {
        $('html').toggleClass('mobile-menu-open');
    });

    $('.sub-menu-toggle').on('click', function() {
        $(this).parent('li').toggleClass('sub-menu-open');
        $(this).parent('li').parent('ul').toggleClass('hide-unopened-items');
    });

    $('.state-support-toggle a').on('click', function(e) {
        e.preventDefault();
        $('html').addClass('state-menu-open');
    });

    $('.close-state-support').on('click', function() {
        $('html').removeClass('state-menu-open');
    });

    /* Handle the main header using headroom.js */
    // grab an element
    const myElement = document.querySelector(".site-header");
    // construct an instance of Headroom, passing the element
    const headroom  = new Headroom(myElement, {
        classes : {
            // when element is initialised
            initial : "headroom",
            // when scrolling up
            pinned : "headroom--scrolling-up",
            // when scrolling down
            unpinned : "headroom--scrolling-down",
            // when above offset
            top : "headroom--top",
            // when below offset
            notTop : "headroom--not-top",
            // when at bottom of scoll area
            bottom : "headroom--bottom",
            // when not at bottom of scroll area
            notBottom : "headroom--not-bottom"
        },
    });
    // initialise
    headroom.init();

    // see whether device supports touch events (a bit simplistic, but...)
    const hasTouch = ("ontouchstart" in window);
    const windowWidth = window.innerWidth;

    // hook touch events for drop-down menus
    // NB: if has touch events, then has standards event handling too
    if (hasTouch && document.querySelectorAll && windowWidth > 1024) {
        var i, len, element,
            dropdowns = document.querySelectorAll(".menu-item-has-children > a");

        function menuTouch(event) {
            // toggle flag for preventing click for this link
            var i, len, noclick = !(this.dataNoclick);

            // reset flag on all links
            for (i = 0, len = dropdowns.length; i < len; ++i) {
                dropdowns[i].dataNoclick = false;
            }

            // set new flag value and focus on dropdown menu
            this.dataNoclick = noclick;
            this.focus();
        }

        function menuClick(event) {
            // if click isn't wanted, prevent it
            if (this.dataNoclick) {
                event.preventDefault();
            }
        }

        for (i = 0, len = dropdowns.length; i < len; ++i) {
            element = dropdowns[i];
            element.dataNoclick = false;
            element.addEventListener("touchstart", menuTouch, false);
            element.addEventListener("click", menuClick, false);
        }
    }

});

